import React from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";
import { Link, Element } from "react-scroll";
import Alerts from "./Alerts";
import SealAndTitle from "./Home/SealAndTitle";
import TopMenu from "./Home/TopMenu";
import ProSeInfo from "./Home/ProSeInfo";
import Litigants from "./Home/Litigants";
import Attorneys from "./Home/Attorneys";
import ContactUs from "./Home/ContactUs";
import Footer from "./Home/Footer";

import "./Home/style/home.css";

import courtSeal from "./Home/images/CourtSeal-no-back.png";

const Home = () => {
  const alert = useSelector((state) => state.alert);

  return (
    <React.Fragment>
      {alert && <Alerts alert={alert} />}
      <Row className="largeHero">
        <Col xs={12} className="opaqueHeroSection">
          <Element name="top" />
          <SealAndTitle courtSeal={courtSeal} />
          <TopMenu ScrollLink={Link} />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs={10}>
          <ProSeInfo ScrollLink={Link} />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center psInfo">
        <Col xs={4}>
          <Element name="litigants" />
          <Row>
            <Col xs={12} className="litigantsFull"></Col>
          </Row>
        </Col>
        <Col xs={6} className="litigantsOne"></Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs={10}>
          <Litigants />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center psInfo">
        <Col xs={4}>
          <Element name="attorneys" />
          <Row>
            <Col xs={12} className="attorneysFull"></Col>
          </Row>
        </Col>
        <Col xs={6} className="attorneysOne"></Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs={10}>
          <Attorneys />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center psInfo">
        <Col xs={4}>
          <Element name="contactUs" />
          <Row>
            <Col xs={12} className="contactUsFull"></Col>
          </Row>
        </Col>
        <Col xs={6} className="contactUsOne"></Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs={10}>
          <ContactUs ScrollLink={Link} />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs={12}>
          <Footer ScrollLink={Link} psInfo={true} />
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default Home;
